import styled from 'styled-components'

// Decisão 46 (nota [CC][F-receita-codigo-acesso]): a rota continua dentro do
// <Layout> padrão do site (header/footer globais) — nada de header mínimo
// próprio nem full-bleed. Só o conteúdo entre eles muda.
export const BaseRecipeContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  width: 100%;
  padding: 1.5rem 1rem 3rem;
`

// Achado 51 (humano, captura real): a D4 (`Desktop-B-produtos.dc.html`) é de
// 1120px (coluna do pedido + aside de 380px) — travar tudo em 840px aqui
// deixava o card do produto estreito. D1/D3 continuam em 840px (largura
// própria aplicada no componente de cada uma); só a D4 usa a largura cheia.
export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.25rem;

  width: 100%;
  max-width: 1120px;
`
